import { Box, styled, TypographyProps } from "@mui/material";
import { StandardCSSProperties,  } from "@mui/system";
import MxTypography from "@rf-l1/MxTypography";
import React from "react";

interface MxButtonStartIconProps {
  onClick?: () => void;
  label: string;
  bgColorIcon: string;
  colorText: TypographyProps["color"];
  icon: React.ReactNode;
  bgColor?: StandardCSSProperties["backgroundColor"];
  id?: string;
}
const MxButtonStartIcon = (props: MxButtonStartIconProps) => {
  return (
    <ContainerButton
      onClick={props?.onClick}
      sx={{ backgroundColor: props.bgColor }}
      id={props.id}
    >
      <ContainerIcon sx={{ bgcolor: props.bgColorIcon || "transparent" }}>
        {props.icon}
      </ContainerIcon>

      <MxTypography
        variant="button"
        color={props.colorText}
        textAlign="center"
        fontWeight={600}
      >
        {props.label}
      </MxTypography>
    </ContainerButton>
  );
};

export default MxButtonStartIcon;

const ContainerIcon = styled(Box)(({ theme }) => ({
  borderRadius: 100,
  p: 0.5,
  width: 25,
  height: 25,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));

const ContainerButton = styled(Box)(({ theme, ...props }) => ({
  cursor: "pointer",
  border: "1px solid #ccc",
  borderRadius: 100,
  transition: "0.3s",
  display: "grid",
  width: "auto",
  // maxWidth: 250,
  gridTemplateColumns: "2rem 1fr",
  gap: 10,
  justifyContent: "center",
  alignItems: "center",
  "&:hover": {
    "& svg": {
      animation: "shake-bottom 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;"
    }
  },
  padding: theme.spacing(0.5, 3, 0.5, 0.5)
}));
